export default __webpack_public_path__ + "static/media/IRANSansWeb.ae01de69.ttf";